import styled from '@emotion/styled';

const TagContainer = styled.div`
    display: inline-flex;
    height: 20px;
    padding: 0px 4px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    border-radius: 4px;
    background: rgba(9, 6, 4, 0.85);

    backdrop-filter: blur(8px);
`;

const Tag = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
    color: ${({ theme }) => theme.colors.white};
    font-family: Manrope !important;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 8px;
`;

interface Props {
    className?: string;
    tagClassName?: string;
    text?: string;
    children?: React.ReactNode;
    type: string;
}

export const AvatarTag = ({ children, text, className, tagClassName, type }: Props) => {
    const content = text || children;

    return (
        <TagContainer data-testid={`avatar-tag-${type}`} className={className}>
            <Tag className={tagClassName}>{content}</Tag>
        </TagContainer>
    );
};
